module.exports = __webpack_public_path__ + "img/3.11d8407f.png";